var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVmLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 .35278 -40.715 28.903)",
    fill: "#bce7a9",
    fillOpacity: 0.94118
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.79 -14.009)",
    fill: "#bce7a9",
    fillOpacity: 0.94118,
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.102-49.921v806.4h573.44v-806.4zm448 197.12h26.882v53.763h-26.882zm-44.8 501.76h-349.44v-71.682h349.44zm26.882-116.48h-403.2v-555.52h403.2zm125.44 0h-107.52v-35.837h107.52zm0-179.2h-107.52v-134.4h107.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.02 290.56h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.78 290.56h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.9 236.8h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.78 236.8h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.02 317.44h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.78 263.68h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.02 263.68h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.9 263.68h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.02 236.8h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.9 317.44h44.8v17.918h-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m530.9 290.56h17.918v17.918h-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.34 586.24h-331.52v53.763h331.52zm-8.9563 35.837h-313.6v-8.9626h313.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902 505.6h367.36v8.9626h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.862 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.62 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.38 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.14 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.9 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.66 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.42 442.88h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902 416h367.36v8.9626h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902 326.4h367.36v8.9626h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.862 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.62 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.38 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.14 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.9 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.66 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.42 353.28h26.882v53.763h-26.882z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.78 272.64v-8.9626h-8.9626v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.54 272.64v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.3 272.64v-8.9626h-8.9626v8.9626h-8.9563v44.8h26.875v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.06 272.64v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.82 272.64v-8.9626h-8.9626v8.9626h-8.9563v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.58 272.64v-8.9626h-8.9626v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.34 272.64v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902 236.8h367.36v8.9626h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902 147.2h367.36v8.9626h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.78 183.04v-8.9626h-8.9626v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.54 183.04v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.3 183.04v-8.9626h-8.9626v8.9626h-8.9563v44.8h26.875v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.06 183.04v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.82 183.04v-8.9626h-8.9626v8.9626h-8.9563v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.58 183.04v-8.9626h-8.9626v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.34 183.04v-8.9626h-8.9563v8.9626h-8.9626v44.8h26.882v-44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.78 76.335v-13.425h3.3626l-6e-3 -5.3187h-15.682v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0125 13.437 13.437 13.437 7.425 0 13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7437-10.775-8.9501-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.54 76.335v-13.425h3.3626v-5.3187h-15.681v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0125 13.437 13.437 13.437s13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7501-10.775-8.9563-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.3 76.335v-13.425h3.3626l-6e-3 -5.3187h-15.682v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0125 13.437 13.437 13.437s13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7437-10.775-8.9501-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.06 76.335v-13.425h3.3626v-5.3187h-15.681v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0125 13.437 13.437 13.437s13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7501-10.775-8.9563-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.82 76.335v-13.425h3.3626v-5.3187h-15.681v5.325h3.3563v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0125 13.437 13.437 13.437 7.4187 0 13.437-6.0125 13.437-13.437v-35.837c0.0128-5.8499-3.7437-10.775-8.9501-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.58 76.335v-13.425h3.3626l-6e-3 -5.3187h-15.681v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0187 13.437 13.437 13.437s13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7437-10.775-8.9501-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.34 76.335v-13.425h3.3626v-5.3187h-15.681v5.325h3.3626v13.425c-5.2062 1.8563-8.9626 6.775-8.9626 12.619v35.837c0 7.425 6.0187 13.437 13.437 13.437s13.437-6.0125 13.437-13.437v-35.837c6e-3 -5.8499-3.7501-10.775-8.9563-12.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.902-5.1213h367.36v44.8h-367.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.06 514.56h89.6v8.9626h-89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.06 156.16h8.9626v35.837h-8.9626z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmLarge);
export default __webpack_public_path__ + "static/media/vm_large.8da76a51b804c1bd8f516065435176ab.svg";
export { ForwardRef as ReactComponent };